import React, { useEffect, useState, Suspense } from "react";
//import RecentUpdates from "./updates/RecentUpdates";
import GeneralUpdates from "./updates/GeneralUpdates";
import FooterAd from "./ads/FooterAd";
import NewsFeed from "./NewsFeed";
import Constants from "../Constants";
import Loading from "./Loading";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
//import LiveChat from "./live/LiveChat";
const RecentUpdates = React.lazy(() => import("./updates/RecentUpdates"));
const StartPage = ({ news }) => {
  let { filter, page, year } = useParams();
  if (!filter) {
    filter = "most_recent";
  }
  if (!year) {
    year = "all";
  }
  if (!page) {
    page = "1";
  }

  const [recentUpdates, setRecentUpdates] = useState([]);
  const [updates, setUpdates] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [maxPages, setMaxPages] = useState(0);
  //const [showLive, setShowLive] = useState(true);
  useEffect(() => {
    //prod `${Constants.API}start-page/${filter}/${year}/${page}`
    //dev api is: `${Constants.API}start-page`
    setLoaded(false);
    fetch(`${Constants.API}start-page/${filter}/${year}/${page}`)
      .then((res) => res.json())
      .then((res) => {
        setRecentUpdates(res.recent);
        setUpdates(res.archives);
        setMaxPages(res.pages);
        setLoaded(true);
      });
  }, [page, filter, year]);
  if (!loaded) {
    return (
      <div className="loadingScreen">
        <Loading size="la-2x" extra=" m200" />
      </div>
    );
  }
  return (
    <div
      className={
        page === "1" && year === "all" && filter === "most_recent"
          ? "main first"
          : "main"
      }
    >
      <Helmet>
        <title>
          All Episodes, {Constants.SORT[filter]}
          {page !== "1" ? ` Page ${page}` : ``}
        </title>
      </Helmet>
      {page === "1" && filter === "most_recent" && year === "all" ? (
        <Suspense fallback={null}>
          <RecentUpdates recentUpdates={recentUpdates} />
        </Suspense>
      ) : (
        <div className="before">
          NVG<span>NETWORK</span>
        </div>
      )}
      <GeneralUpdates
        label1={"Video"}
        label2={"Archive"}
        updates={updates}
        currentSite=""
        maxPages={maxPages}
        path={`${filter}/${year}/`}
        filter={filter}
        year={year}
        isNetwork={false}
      />
      <FooterAd />
      <NewsFeed news={news} />
      {/* {showLive && <LiveChat handleClose={() => setShowLive(false)} />} */}
    </div>
  );
};

export default StartPage;
